module.exports = __webpack_public_path__ + "img/close.55ece683.svg";